export const TooltipVariant = {
  light: 'light',
  dark: 'dark',
} as const

export const TooltipTriggers = {
  manual: 'manual',
  click: 'click',
  hover: 'hover',
  focus: 'focus',
} as const

export const DEFAULT_DELAY_MS = 750
